export default "__VITE_ASSET__aa8a47e9__"